export enum FILE_ERROR_TYPE {
  MAX_FILES = 'MAX_FILES',
  MAX_FILE_SIZE = 'MAX_FILE_SIZE',
  ALLOWED_FILE_TYPES = 'ALLOWED_FILE_TYPES',
}

export interface DragAndDropConfigs {
  maxFiles: number;
  maxFileSize: number;
  allowedFileTypes: string[];
}

export interface DragAndDropFileError {
  message: string;
  type: FILE_ERROR_TYPE;
}

export interface DragAndDropFile {
  file?: File;
  errors: DragAndDropFileError[];
}

export interface DragAndDropReport {
  genericError?: DragAndDropFileError;
  items?: DragAndDropFile[];
}

export interface DragAndDropValidation {
  (report: DragAndDropFile[], config: DragAndDropConfigs): DragAndDropReport;
}
